import React, { createContext, useContext } from "react";
import { useGlobalReducer } from "./reducer";

const GlobalContext = createContext();
const { Provider } = GlobalContext;

const GlobalProvider = ({ value = [], ...props }) => {
  const [state, dispatch] = useGlobalReducer({
    setModalExample: false,
    reviews: [],
    rating: 0,
    userRatingCount: 0,
    bookingUrl: "https://www.fresha.com/a/birmingham-chiropractic-birmingham-264-alcester-road-south-xp8i2pdf/booking?menu=true&pId=34323&dppub=true&employeeId=96632"
  });

  return <Provider value={[state, dispatch]} {...props} />;
};

const useGlobalContext = () => {
  return useContext(GlobalContext);
};

export { GlobalProvider, useGlobalContext };
